module.exports = __webpack_public_path__ + "static/media/PuestaDeSol.02af2818.png";